module.exports = __webpack_public_path__ + "img/tarj2-1.2344a635.svg";